import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageWrapper from "./PageWrapper";
import { useQuizContext } from "./QuizContext";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import {
  updateExistingPatient,
  updateWeight,
  submitIntakeForm,
} from "../../services/api";
import "./SignupCommon.css";
import Alert from "../../assets/images/alert.png";
const SignupPage16: React.FC = () => {
  const [addressLine1, setAddressLine1] = useState<string>("");
  const [addressLine2, setAddressLine2] = useState<string>("");
  const [city, setCity] = useState<string>("");
  const [state, setState] = useState<string>("");
  const [zip, setZip] = useState<string>("");
  const { setAnswer, answers } = useQuizContext();
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [height, setHeight] = useState<string>("");
  const [patientId, setPatientId] = useState<string>("");
  const navigate = useNavigate();
  const [storedData, setStoredData] = useState<Record<string, any>>({});
  const [stateError, setStateError] = useState<string>("")
  const [zipError, setZipError] = useState<string>("");
  const [uuidValue, setUuidValue] = useState<string>("");
  const [disableAddress, setDisableAddress] = useState<boolean>(false);
  useEffect(() => {
    const getItem = localStorage.getItem("uuid");
    if (getItem) {
      setUuidValue(JSON.parse(getItem).value);
    }
  });
  useEffect(() => {
    setUuidValue(uuidValue);
  }, [uuidValue]);
  useEffect(() => {
    const allValues: Record<string, any> = {};
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) {
        const value = localStorage.getItem(key);
        try {
          allValues[key] = JSON.parse(value || "");
        } catch {
          allValues[key] = value;
        }
      }
    }
    setStoredData(allValues);
  }, []);

  const handleNext = async () => {
    if (addressLine1 && city && state && zip) {
      // Save answers to context
      localStorage.setItem(
        "addressLine1",
        JSON.stringify({ key: "addressLine1", value: addressLine1 })
      );
      localStorage.setItem(
        "addressLine2",
        JSON.stringify({ key: "addressLine2", value: addressLine2 })
      );
      localStorage.setItem(
        "city",
        JSON.stringify({ key: "city", value: city })
      );
      localStorage.setItem(
        "state",
        JSON.stringify({ key: "state", value: state })
      );
      localStorage.setItem("zip", JSON.stringify({ key: "zip", value: zip }));

      setAnswer("addressLine1", addressLine1);
      setAnswer("addressLine2", addressLine2);
      setAnswer("city", city);
      setAnswer("state", state);
      setAnswer("zip", zip);

      try {
        setLoader(true); // Start loading before API calls
        const [month, day, year] = storedData.dob.value.split("/");
        const formattedDobForApi = `${month}/${day}/${year}`;
        const productCategory = "GLP1"; 

        const updatePatientResponse = await updateExistingPatient(
          storedData.email.value,
          formattedDobForApi,
          storedData.gender.value,
          storedData.height.value,
          storedData.weight.value,
          city,
          addressLine1,
          addressLine2,
          state,
          zip,
          storedData.phone.value,
          productCategory,
          uuidValue
        );
        // Navigate to the next step
        navigate("/getting-started/step-12");
        localStorage.setItem("step-11-completed", "true");
      } catch (error) {
        console.error("Error updating details:", error);
        alert("Failed to update your details. Please try again.");
      } finally {
        setLoader(false);
      }
    } else {
      alert("Please fill in all the required fields.");
    }
  };
  useEffect(() => {
    const step10Completed = localStorage.getItem("step-10-completed");
    if (step10Completed) {
      navigate("/getting-started/step-11",{ replace: true });
    } else {
      navigate("/getting-started/step-10",{ replace: true });
    }
  }, []);
  useEffect(() => {
    const savedAddressLine1 = localStorage.getItem("addressLine1");
    const savedAddressLine2 = localStorage.getItem("addressLine2");
    const savedCity = localStorage.getItem("city");
    const savedState = localStorage.getItem("state");
    const savedZip = localStorage.getItem("zip");
    const savedDisableAddress = localStorage.getItem("disable_address");

    if(savedDisableAddress){
      setDisableAddress(JSON.parse(savedDisableAddress).value);
    }
    if (savedAddressLine1) {
      const parsedAddressLine1 = JSON.parse(savedAddressLine1);
      setAddressLine1(parsedAddressLine1.value);
    }
    if (savedAddressLine2) {
      const parsedAddressLine2 = JSON.parse(savedAddressLine2);
      setAddressLine2(parsedAddressLine2.value);
    }
    if (savedCity) {
      const parsedCity = JSON.parse(savedCity);
      setCity(parsedCity.value);
    }
    if (savedState) {
      const parsedState = JSON.parse(savedState);
      setState(parsedState.value);
    }
    if (savedZip) {
      const parsedZip = JSON.parse(savedZip);
      setZip(parsedZip.value);
    }
  }, []);

  const styles = {
    container: {
      maxWidth: "500px",
      margin: "0 auto",
    },
    content: {
      marginTop: "20px",
    },
    label: {
      marginBottom: "10px",
      fontWeight: "bold",
    },
    inputContainer: {
      marginBottom: "20px",
      width: "100%",
    },
    input: {
      width: "560px",
      height: "52px",
      padding: "10px",
      fontSize: "16px",
      border: "1px solid #D9D9D9",
      borderRadius: "154px",
      background: "#FFF",
    },
    button: {
      backgroundColor: "#007bff",
      color: "white",
      padding: "10px 20px",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      fontSize: "16px",
      marginTop: "20px",
    },
    disabledButton: {
      backgroundColor: "#ccc",
      cursor: "not-allowed",
    },
    checkboxLabel: {
      fontSize: "14px",
      color: "#333",
      marginTop: "10px",
    },
    checkboxContainer: {
      display: "flex",
      alignItems: "center",
    },
    addressRow: {
      display: "flex",
      justifyContent: "space-between",
      gap: "10px",
    },
    inlineInput: {
      width: "260px",
    },
  };
  useEffect(() => {
    if (zip.length === 5) {
      setZipError("");
    }
  }, [zip]);
  const step = 10;
  const stateOptions = {
    AK: "Alaska",
    AL: "Alabama",
    AR: "Arkansas",
    AZ: "Arizona",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DC: "District of Columbia",
    DE: "Delaware",
    FL: "Florida",
    GA: "Georgia",
    HI: "Hawaii",
    IA: "Iowa",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    MA: "Massachusetts",
    MD: "Maryland",
    ME: "Maine",
    MI: "Michigan",
    MN: "Minnesota",
    MO: "Missouri",
    MS: "Mississippi",
    MT: "Montana",
    NC: "North Carolina",
    ND: "North Dakota",
    NE: "Nebraska",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NV: "Nevada",
    NY: "New York",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VA: "Virginia",
    VT: "Vermont",
    WA: "Washington",
    WI: "Wisconsin",
    WV: "West Virginia",
    WY: "Wyoming",
  };
  const handleStateChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedState = e.target.value as keyof typeof stateOptions; // Type assertion
    
    // if(selectedState === "LA"){
    //   setState("");
    //   setStateError("Sorry, currently we do not offer the medication in Louisiana.");
    //   localStorage.removeItem("state");
    //   localStorage.removeItem("fullState");
    // }else{
    //   setStateError("");
    // }
      setState(selectedState);
      localStorage.setItem(
        "state",
        JSON.stringify({ key: "state", value: selectedState })
      );
      localStorage.setItem(
        "fullState",
        JSON.stringify({ key: "fullState", value: stateOptions[selectedState] })
      );
  };

  const handleZipCode = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setZip(value)
    if (value.length !== 5) {
      setZipError("Please enter a valid zipcode");
      return false;
    } else {
      setZipError("");
    }
   
  }

  return (
    <PageWrapper>
      <div className="signup-page-container">
        <ProgressBar progress={100} step={step} />
        <div className="signup-content">
          <p className="signup-intro-info">
            Let's make sure we can offer our services at your location
          </p>
          <p className="signup-intro-para-second" style={{ marginBottom: 30 }}>
            To receive your tailored medication plan and begin your wellness
            journey with Claya, enter the following contact information.
          </p>

          <div style={styles.inputContainer}>
            <input
              type="text"
              value={addressLine1}
              onChange={(e) => setAddressLine1(e.target.value)}
              disabled={disableAddress}
              placeholder="Address Line 1"
              className="input-fields"
            />
          </div>

          <div style={styles.inputContainer}>
            <input
              type="text"
              value={addressLine2}
              disabled={disableAddress}
              onChange={(e) => setAddressLine2(e.target.value)}
              placeholder="Address Line 2 (Optional)"
              className="input-fields"
            />
          </div>

          <div className="select-container">
            <select
              id="state"
              name="state"
              value={state}
              disabled={disableAddress}
              onChange={handleStateChange} // Use the new handler
              className="minimal bg-red mb-0 items-center justify-center border border-gray-200 align-middle text-sm border-red-200 rounded-md outline-none focus:outline-none"
            >
              <option value="">Select a state</option>
              {Object.entries(stateOptions).map(([abbreviation, fullName]) => (
                <option key={abbreviation} value={abbreviation}>
                  {fullName}
                </option>
              ))}
            </select>
          </div>
          <div className="input-row">
            <input
              type="text"
              value={city}
              disabled={disableAddress}
              onChange={(e) => setCity(e.target.value)}
              placeholder="City"
              className="input-fields"
            />
            <input
              type="number"
              value={zip}
              disabled={disableAddress}
              onChange={handleZipCode}
              placeholder="ZIP Code"
              className="input-fields"
            />
          </div>
          <div style={{ display: 'flex', flexDirection:"column", gap:'20px'}}>
          {stateError && (
            <div className="state-error">
              <img src={Alert} alt="state-error" width={"16px"} height={"15px"}/>
              <p className="state-error-text">{stateError}</p>
            </div>
          )}
          {zipError && (
           <div className="state-error">
           <img src={Alert} alt="state-error" width={"16px"} height={"15px"}/>
           <p className="state-error-text">{zipError}</p>
         </div>
          )}
          </div>
          
          <button
            onClick={handleNext}
            disabled={!addressLine1 || !city || !state || !!stateError || !zip || !!zipError || loader}
            className="next-btn"
            style={{
              backgroundColor:
              !addressLine1 || !city || !state || !!stateError || !zip || !!zipError || loader
                  ? "#d3d3d3"
                  : "#0c3972",
            }}
          >
            {loader ? "Loading..." : "Continue →"}
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default SignupPage16;